/** Activity tab - chronological log of actions/events for this supplier. Demo Mode only,
 * local-only mock data - see `supplierProfileData.ts`. */

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box, Stack, Typography,
} from '@mui/material';
import { Section } from '../../../../../components/ui/Section';
import { getSupplierActivity } from '../../../../../mocks/data/supplierProfileData';

export interface ActivityTabProps {
  supplierId: number;
}

const ActivityTab: React.FC<ActivityTabProps> = ({ supplierId }) => {
  const { t } = useTranslation('suppliers');
  const activity = useMemo(() => getSupplierActivity(supplierId), [supplierId]);

  return (
    <Section>
      <Box sx={{ p: 4 }}>
        <Typography variant="textSM"
          fontWeight={600}
          sx={{ mb: 3 }}>{t('activityLog', 'Activity')}</Typography>

        {activity.length === 0 && (
          <Typography variant="textSM"
            color="text.secondary">{t('noActivity', 'No activity recorded yet.')}</Typography>
        )}

        <Stack spacing={3}>
          {activity.map((entry) => (
            <Box key={entry.id}
              sx={{ borderLeft: '2px solid', borderColor: 'divider', pl: 3 }}>
              <Typography variant="textXS"
                color="text.secondary">{entry.date} - {entry.actor}</Typography>
              <Typography variant="textSM">{entry.action}</Typography>
            </Box>
          ))}
        </Stack>
      </Box>
    </Section>
  );
};

export default ActivityTab;
